__turbopack_context__.v({
  "desktopOnly": "tranche-module-scss-module__gAq-Sq__desktopOnly",
  "dropped": "tranche-module-scss-module__gAq-Sq__dropped",
  "gridContainer": "tranche-module-scss-module__gAq-Sq__gridContainer",
  "gridItem": "tranche-module-scss-module__gAq-Sq__gridItem",
  "mobileOnly": "tranche-module-scss-module__gAq-Sq__mobileOnly",
  "tranche": "tranche-module-scss-module__gAq-Sq__tranche",
  "trancheContainer": "tranche-module-scss-module__gAq-Sq__trancheContainer",
});
